import { render, staticRenderFns } from "./goFlexRequestsHistory.vue?vue&type=template&id=0d67751c"
import script from "./goFlexRequestsHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./goFlexRequestsHistory.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports